import React from 'react';
import AdmissionForm from '../components/AdmissionForm';
import Footer from '../components/Footer';

function AdmissionFormPage() {
  return (
    <>
      <AdmissionForm />
      <Footer />
    </>
  );
}

export default AdmissionFormPage;
